import { useState } from 'react';
import { Quote } from '../Quote/Quote';
import { SegmentControl } from '../SegmentControl';
import styles from './HowDoI.module.scss';
import { ListItem } from '../ListItem';

export type GridContent = {
  title: string;
  description: React.ReactNode;
};

export type Segment = {
  header: string;
  imageUrl: string;
  imageAlt: string;
  gridContent: GridContent[];
  quote: {
    author: string;
    quote: string;
    isTrustPilot?: boolean;
    avatarUrl?: string;
  };
};

export interface HowDoIProps {
  segments: Segment[];
}

export const HowDoI = ({ segments }: HowDoIProps) => {
  const [active, setActive] = useState(0);

  const segmentHeaders = segments.map(({ header }) => header);

  const getActiveContent = (idx: number) => {
    const { imageUrl, imageAlt, gridContent, quote } = segments[idx];
    return (
      <div className={`${styles.contentContainer}`}>
        {/* Superpower Image */}
        <img className={`${styles.superPowerImage}`} src={imageUrl} alt={imageAlt} />

        {/* Grid Content */}
        <ListItem items={gridContent} />

        {/* Quote Component */}
        <Quote {...quote} />
      </div>
    );
  };

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.segmentControl}`}>
        <h2 className={`${styles.segmentControlTitle}`}>How do I...?</h2>
        <SegmentControl
          active={active}
          headers={segmentHeaders}
          setActive={setActive}
          content={getActiveContent(active)}
        />
      </div>
    </div>
  );
};
